import { AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import { Title} from '@angular/platform-browser';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DynamicBarService} from '../../../_components/dynamic-bar/dynamic-bar.service';
import { ActivatedRoute, Router} from '@angular/router';
import { Periodo} from '../../../_models/interfaces';
import { NavBarObject} from '../../../_components/nav-bar/config';

@Component({
    selector: 'nivelaciones-director-curso',
    standalone: false,
    templateUrl: 'nivelaciones-director-curso.component.html',
    styleUrls: [
        '../citacion-materia-curso/citacion-materia-curso.component.scss',
        '../nivelaciones-directivo/nivelaciones-directivo.component.scss',
        './nivelaciones-director-curso.component.scss',
        '../../estudio/materias-familia/materia-unidades/materia-unidades.component.scss'
    ],
    host: {
        '(click)': 'offClick($event)'
    }
})

export class NivelacionesDirectorCursoComponent implements OnInit, AfterViewInit {

    dataSource: MatTableDataSource<any>;
    displayedColumns = ['Alumno'];
    @ViewChild(MatSort, { static: true }) sort: MatSort;

    periodosNavBar;
    periodoSeleccionado = 0;
    curso: string;

    tableWidth;

    constructor(private titleService: Title,
                private dynamicBarService: DynamicBarService,
                private route: ActivatedRoute,
                private router: Router,
                private elRef: ElementRef) {
    }

    ngOnInit() {
        const cursoID = this.route.snapshot.paramMap.get('id');

        this.route.parent.data.subscribe((data: { periodos: Periodo[] }) => {
            const periodo = data.periodos[0];
            this.periodosNavBar = [new NavBarObject(
                periodo.nombre,
                [`/nivelaciones/reportes/director-curso/${cursoID}/periodo/${periodo.id}`],
                periodo.id,
                [new NavBarObject('Acumulado',
                    [`/nivelaciones/reportes/director-curso/${cursoID}/periodo/${periodo.id}`],
                    periodo.id)].concat(
                    periodo.periodos.map(child => {
                        if (child.tipo < 2) {
                            return new NavBarObject(`Periodo ${child.nombre}`, [`/nivelaciones/reportes/director-curso/${cursoID}/periodo/${child.id}`], child.id);
                        } else {
                            return false;
                        }
                    }))
            )];
        });

        this.route.data.subscribe((data: { nivelaciones }) => {
            this.tableWidth = 240 + (data.nivelaciones.materiasEncabezado.length * 132) + 48;
            data.nivelaciones.materiasEncabezado.map(materia => {
                this.displayedColumns.push(`${materia.nombreCompleto}`);
            });
            this.dataSource = new MatTableDataSource<any>(data.nivelaciones.alumnos);
            this.curso = data.nivelaciones.nickName;
        });

        this.titleService.setTitle('Director de curso - Nivelaciones');
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    }

    ngAfterViewInit() {
        this.dataSource.sortingDataAccessor = (item, property) => {
            switch (property) {
                case 'Alumno':
                    return item.alumno.apellidosNombres;
                default:
                    return item[property];
            }
        };
        this.dataSource.sort = this.sort;
        this.dynamicBarService.setBarra('nivelaciones-citacion-mcp-barra', {curso: this.curso});
    }

    toggleDetalles(detalleElement, evt) {
        evt.stopPropagation();
        const els = this.elRef.nativeElement.querySelectorAll('.detalle'),
            control = detalleElement.hidden;
        els.forEach(el => {
            el.hidden = true;
        });
        if (control) {
            detalleElement.hidden = false;
        } else {
            detalleElement.hidden = true;
        }
    }

    offClick(evt) {
        if (!evt.target.classList.contains('circulo') && !evt.target.classList.contains('detalle')
            && !evt.target.classList.contains('detalle-lista') && !evt.target.classList.contains('detalle-item')) {
            const els = Array.prototype.slice.call(this.elRef.nativeElement.querySelectorAll('.detalle')),
                shownEl = els.filter(el => el.hidden === false);
            if (shownEl.length === 1) {
                shownEl[0].hidden = true;
            }
        }
    }
}
